  // Check if the cookie banner was acknowledged
  function checkCookieBanner() {
    if (localStorage.getItem('cookieBannerAcknowledged') !== 'TRUE') {
      showCookieBanner();
    } else {
      // NEW: Returning visitor — banner won't show, but Shopify's privacy state
      // resets each session. We need to re-grant consent so all web pixels
      // (Google, Bing, Facebook, Klaviyo, etc.) know the user already accepted.
      grantShopifyConsent();
    }
  }

  // Show cookie banner
  function showCookieBanner() {
    const cookieBanner = document.querySelector('.banner-bar');
    if (cookieBanner) {
      cookieBanner.style.display = 'flex';

      // Start countdown ring animation
      const ring = cookieBanner.querySelector('.cookie-close__countdown');
      if (ring) {
        // Force reflow so the animation starts cleanly
        ring.getBoundingClientRect();
        ring.classList.add('--animating');
      }

      // Auto-close after 5 seconds
      const autoCloseTimer = setTimeout(() => {
        dismissBanner(cookieBanner);
      }, 5000);

      // Store timer so manual close can clear it
      cookieBanner._autoCloseTimer = autoCloseTimer;

      // Grant consent after 200ms (same timing as before)
      setTimeout(() => {
        localStorage.setItem('cookieBannerAcknowledged', 'TRUE');

        // NEW: Grant consent via Shopify Privacy API — this fires the
        // "visitorConsentCollected" event which ALL web pixels listen for
        // (Google, Bing, Facebook, Klaviyo, ProfitMetrics, etc.)
        grantShopifyConsent();

        // OLD: Previously we called updateConsent() which only told Google.
        // updateConsent();
        // loadGtagScript();
      }, 200);
    }
  }

  // Dismiss the banner
  function dismissBanner(banner) {
    if (banner) {
      banner.style.display = 'none';
    }
  }

  // NEW: Grant consent via Shopify's Customer Privacy API.
  // This tells ALL web pixels (Google, Bing, Facebook, Klaviyo, etc.) at once
  // via the "visitorConsentCollected" event that Shopify's WPM listens for.
  function grantShopifyConsent() {
    // Wait for Shopify's consent-tracking-api to be available
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        function (error) {
          if (error) {
            console.error('Error loading Shopify consent API:', error);
            return;
          }
          // Grant all consent categories — mirrors what updateConsent() did
          // but through Shopify's API so every pixel gets notified
          window.Shopify.customerPrivacy.setTrackingConsent(
            {
              marketing: true,
              analytics: true,
              preferences: true,
              sale_of_data: true,
            },
            function () { /* consent set successfully */ }
          );
        }
      );
    }
  }

  // OLD: updateConsent() — only updated Google's gtag, no other pixels.
  // Kept here commented out so you can revert if needed.
  //
  // function updateConsent() {
  //   window.dataLayer = window.dataLayer || [];
  //   function gtag(){dataLayer.push(arguments);}
  //   gtag('consent', 'update', {
  //     ad_user_data: 'granted',
  //     ad_personalization: 'granted',
  //     ad_storage: 'granted',
  //     analytics_storage: 'granted'
  //   });
  // }

  // OLD: loadGtagScript() — manually injected a duplicate gtag.js script.
  // No longer needed as Shopify's Google & YouTube channel handles this.
  //
  // function loadGtagScript() {
  //   var gtagScript = document.createElement('script');
  //   gtagScript.async = true;
  //   gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-619838969';
  //   var firstScript = document.getElementsByTagName('script')[0];
  //   firstScript.parentNode.insertBefore(gtagScript, firstScript);
  // }

  // Close cookie banner on button click
  function closeCookieBanner() {
    const closeButton = document.querySelector('.cookie-close');
    const cookieBanner = document.querySelector('.banner-bar');

    if (closeButton) {
      closeButton.addEventListener('click', function() {
        clearTimeout(cookieBanner._autoCloseTimer);
        dismissBanner(cookieBanner);
      });
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    checkCookieBanner();
    closeCookieBanner();
  });
